import { PriceType } from "@/models/Interfaces";
import { useI18n } from "vue-i18n";
import { ProductListItem } from "@/models/Product";
import moment, { Moment } from "moment";
import { OrderProduct } from "./models/Order";
import _ from "lodash";
export default {
  methods: {
    getPriceTypeName(
      priceType: PriceType | undefined,
      currentLanguageId: number
    ) {
      const translation = priceType?.translations?.find(
        (x) => x.languageId == currentLanguageId
      );
      if (translation) {
        return translation.name;
      }
      if (priceType) {
        const key = priceType.name.toLowerCase().replace(" ", "-");
        return useI18n().t(key);
      }
      return "";
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatAmount(item: number | string): string {
      if (!item) {
        return "0";
      }
      let result = (
        Math.round((Number(item) + Number.EPSILON) * 100) / 100
      ).toString();

      const arrRes = result.split(".");
      if (arrRes.length > 1) {
        const first = arrRes[0]
          .replace(/[^-0-9]/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        result = first + "." + arrRes[1];
      } else {
        result = arrRes[0]
          .replace(/[^-0-9]/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        result += ".00";
      }
      return result;
    },
    formatDate(date: Moment): string {
      return date.format('DD/MM/YYYY');
    }
    ,
    formatDateString(date: string): string {
      return moment(date).format('DD/MM/YYYY');
    },
    isDecimalNumber: function(evt: any) {
        evt = evt ? evt : window.event;
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) evt.preventDefault();
        else return true;
    },
    getDateToTitle(date: string) {
        const newDate = new Date(date);
        return moment(newDate).format('DD/MM/YYYY');
    },
    orderChanged(orderProducts1: OrderProduct[], orderProducts2: OrderProduct[]) {
      const clonedOrderProducts1 = _.cloneDeep(orderProducts1);
      const clonedOrderProducts2 = _.cloneDeep(orderProducts2);

      return _.isEqual(clonedOrderProducts1, clonedOrderProducts2);
    }
  },
};
